type SelectedQuoteCommission = {
  percentage: any;
  amount: any;
  currency: string;
};

type SelectedQuotePayloadBase = Record<string, unknown>;

function toFiniteNumber(value: unknown): number | null {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const normalized = String(value ?? "").trim();
  if (!normalized) {
    return null;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function resolveCommission(quote: any): SelectedQuoteCommission | null {
  const rawCommission = quote?.plan?.commission;
  if (!rawCommission || typeof rawCommission !== "object") {
    return null;
  }

  const percentage = toFiniteNumber(rawCommission.percentage);
  const amount = toFiniteNumber(rawCommission.amount);
  const currency = String(rawCommission.currency ?? "").trim();

  if (percentage === null || amount === null || !currency) {
    return null;
  }

  return {
    percentage,
    amount,
    currency,
  };
}

export function withB2CSelectedQuoteCommission(
  payload: SelectedQuotePayloadBase,
  quote: any
): SelectedQuotePayloadBase {
  const commission = resolveCommission(quote);
  if (!commission) {
    return payload;
  }

  return {
    ...payload,
    commission,
  };
}
